import CleaningIcon from '../Images/cleaning-icon.svg'


const carpets = [

    {
        id: 26, 
        image: CleaningIcon,
        option: 'Lounge / Dining Room',
        desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
    },{
        id: 27, 
        image: CleaningIcon,
        option: 'Through Lounge',
        desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
    },
    {
        id: 28, 
        image: CleaningIcon,
        option: 'Hallway',
        desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
    },{
        id: 29, 
        image: CleaningIcon,
        option: 'Staircase',
        desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
    },{
        id: 30, 
        image: CleaningIcon,
        option: 'Single Bedroom',
        desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
    },{
        id: 31, 
        image: CleaningIcon,
        option: 'Medium Rug',
        desc: 'Deep Cleaning Of Carpet, Using Water Extractor Machine, Eco-Friendly Products, Quick Dry'  
    },

]


export default carpets;